import { useMemo } from 'react';

function getValue(values, key) {
  if (!values) return undefined;
  return values[key];
}

function matchesRule(value, rule) {
  switch (rule.operator) {
    case 'not_equals':
      return value !== rule.value;
    case 'contains':
      if (Array.isArray(value)) return value.includes(rule.value);
      return String(value || '').includes(String(rule.value || ''));
    case 'not_contains':
      if (Array.isArray(value)) return !value.includes(rule.value);
      return !String(value || '').includes(String(rule.value || ''));
    case 'is_empty':
      return value == null || value === '' || (Array.isArray(value) && value.length === 0);
    case 'is_not_empty':
      return !(value == null || value === '' || (Array.isArray(value) && value.length === 0));
    case 'equals':
    default:
      return value === rule.value;
  }
}

function evaluateRules(rules, operator, values) {
  if (!rules || rules.length === 0) return true;
  if (operator === 'or') {
    return rules.some((rule) => matchesRule(getValue(values, rule.fieldKey), rule));
  }
  return rules.every((rule) => matchesRule(getValue(values, rule.fieldKey), rule));
}

export function useConditionalLogic(fields, values) {
  return useMemo(() => {
    const visibility = {};
    (fields || []).forEach((field) => {
      const logic = field.conditionalLogic;
      if (!logic || !logic.rules || logic.rules.length === 0) {
        visibility[field.fieldKey] = true;
        return;
      }
      const matches = evaluateRules(logic.rules, logic.operator || 'and', values);
      visibility[field.fieldKey] = logic.action === 'hide' ? !matches : matches;
    });
    return visibility;
  }, [fields, values]);
}


